import type { ApiReturnResource, ITagService} from "./ITagService";
import { api_config } from "../../../api-commons";
import { ApiReturnResourcesTags, ApiReturnTag } from "@highimpact-frontend/api-types";

export type ApiTag = {
    name: string,
    is_generic: boolean
}

export type TagAssociation = {
    tags: string[],
    project_id: number
}

class TagService implements ITagService {
    
    async add(params: ApiTag): Promise<ApiReturnTag> {
        const newTag = { name: params.name, is_generic: false };
        const response = await api_config.post(`/tags`, newTag);
        return response.data;
    }
    
    async getAll(): Promise<ApiReturnTag[]> {
        const response = await api_config.get(`/tags`);
        return response.data;
    }
    
    async getAllResourcesTags(): Promise<ApiReturnResourcesTags[]>{
        const response = await api_config.get(`/resources_tags/`);
        return response.data;
    }
    
    async getAllFromProject(project_id: number): Promise<ApiReturnTag[]> {
        const queryParams = `project_id=${project_id}`;
        const response = await api_config.get(`/project_tags?${queryParams}`);
        return response.data;
    }


    async associateTagToProject(tags: string[], projectId: number): Promise<ApiReturnTag> {
        const newTag = { tags: [tags[0]], project_id: projectId };
        const response = await api_config.post(`/project_tags`, newTag);
        return response.data;
    }

    async associateTagToResource(resourceId: number, tags: string[]): Promise<ApiReturnTag> {
        const newTag = { resource_id: resourceId, tags: tags };
        const response = await api_config.post(`/resource_tag/`, newTag);
        return response.data;
    }

    async deleteFromResource(resourceId: number, tags: string[]): Promise<ApiReturnResource> {
        const queryParams = `resource_id=${resourceId}${tags.length !== 0 && tags.map(tag => `&tags=${tag}`).join('')} `;
        const response = await api_config.delete(`/resource_tag/?${queryParams}`);
        return response.data;
    }
}

const tagServiceInstance = new TagService();
export default tagServiceInstance;